<template >
    <div class="orders">
        <order-list-full-component :sorting= true :date="date" :filtered="filtered"/>
    </div>
</template>
<script setup lang="ts">
import orderListFullComponent from '../shared/orderListFullGravesComponent.vue'
import { ref } from 'vue'

const date = ref([])
const filtered = ref(false)
function clearFilters() {
    date.value = []
    filtered.value = false
}
</script>